import {getCookie} from '../app.js';
class NewLearnerComponent extends HTMLElement {
    constructor() {
        // Always call super first in the constructor
        super();
    }

    // Specify observed attributes for watching
    static get observedAttributes() {
        return ['json'];
    }

    // Lifecycle method called when the custom element is first connected to the document's DOM.
    connectedCallback() {
        var websiteurl = getCookie('WEBSITE_URL');
        const c_websiteurl = websiteurl;

        function safeParse(data) {
            if (typeof data === 'string') { try { return JSON.parse(data); } catch(e) { return data; } }
            return data;
        }

        var _chevron = "<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#9ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>";
        var _sectionStyle = 'border:1px solid #e6e7e9;border-radius:6px;margin-bottom:8px;overflow:hidden;';
        var _summaryStyle = 'display:flex;align-items:center;justify-content:space-between;padding:7px 14px;background:#f4f6fa;border-bottom:1px solid #e6e7e9;cursor:pointer;list-style:none;font-size:11px;font-weight:700;letter-spacing:.06em;color:#6b7280;text-transform:uppercase;user-select:none;';
        var _bodyStyle = 'padding:12px 14px;font-size:12px;';
        this.innerHTML = "<h3 id='learner-heading' style='display:none;'></h3>" +
            " <form class=\"form-horizontal\" id=\"frm-main\">" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Learner " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='learner-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Mother Info " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='mother-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Father Info " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='father-container' style='display:none;'></div></div>" +
            "  </details>" +
            " <br />" +
            "</form>" +
            "";

        function html_entity_decode(str) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = str;
            return textArea.value;
        }
        function motherForm() {
            $("#mother-container").html(
                "  " +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">NAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control\" id=\"motherFirstname\" placeholder=\"Enter mother name\" name=\"motherFirstname\" value='" + "" + "'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">SURNAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"motherLastname\" placeholder=\"Enter mother last name\" name=\"motherLastname\" value='" + "" + "'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">CELLPHONE:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <div class=\"input-group\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"motherCell\" placeholder=\"Enter mother cell\" name=\"motherCell\" value='" + "" + "'>" +
                "          <span class=\"input-group-addon\" style='min-width: 50px;'><img src=\"/img/tabler/phone.svg\" alt=\"\" style=\"height: 18px; width: 18px;\" /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">EMAIL:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <div class=\"input-group\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"motherEmail\" placeholder=\"Enter mother email\" name=\"motherEmail\" value='" + "" + "'>" +
                "          <span class=\"input-group-addon\" style='min-width: 50px;'><img src=\"/img/tabler/mail.svg\" alt=\"\" style=\"height: 18px; width: 18px;\" /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                " "
            );

            // Sleep 1/2 second and then show.
            setTimeout(function() {
                $('#mother-container').show();
            }, 500);
        }

        function fatherForm(json) {
            $("#father-container").html(
                "  " +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">NAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control\" id=\"fatherFirstname\" placeholder=\"Enter father name\" name=\"fatherFirstname\" value='" + "" + "'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">SURNAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"fatherLastname\" placeholder=\"Enter father last name\" name=\"fatherLastname\" value='" + "" + "'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">CELLPHONE:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <div class=\"input-group\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"fatherCell\" placeholder=\"Enter father cell\" name=\"fatherCell\" value='" + "" + "'>" +
                "          <span class=\"input-group-addon\" style='min-width: 50px;'><img src=\"/img/tabler/phone.svg\" alt=\"\" style=\"height: 18px; width: 18px;\" /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">EMAIL:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <div class=\"input-group\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"fatherEmail\" placeholder=\"Enter father email\" name=\"fatherEmail\" value='" + "" + "'>" +
                "          <span class=\"input-group-addon\" style='min-width: 50px;'><img src=\"/img/tabler/mail.svg\" alt=\"\" style=\"height: 18px; width: 18px;\" /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                " "
            );

            // Sleep 1/2 second and then show.
            setTimeout(function() {
                $('#father-container').show();
            }, 500);
        }

        function enforceTermLocks() {
            var termLocksRequest = $.get(c_websiteurl + "app.php/learners/termLocks/");
            var currentTermRequest = $.get(c_websiteurl + "app.php/learners/currentTerm/");

            $.when(termLocksRequest, currentTermRequest)
                .done(function (locksResponse, currentTermResponse) {
                    var locks = locksResponse[0] || {};
                    var currentTermData = currentTermResponse[0] || {};
                    var currentTerm = parseInt(currentTermData.term, 10);

                    applyTermLockForNewLearner('#term1', locks.term1Lock, currentTerm === 1);
                    applyTermLockForNewLearner('#term2', locks.term2Lock, currentTerm === 2);
                    applyTermLockForNewLearner('#term3', locks.term3Lock, currentTerm === 3);
                    applyTermLockForNewLearner('#term4', locks.term4Lock, currentTerm === 4);
                })
                .fail(function () {
                    // Fallback to previous behaviour: apply locks without current term awareness.
                    $.get(c_websiteurl + "app.php/learners/termLocks/")
                        .done(function (data) {
                            applyTermLockForNewLearner('#term1', data.term1Lock, false);
                            applyTermLockForNewLearner('#term2', data.term2Lock, false);
                            applyTermLockForNewLearner('#term3', data.term3Lock, false);
                            applyTermLockForNewLearner('#term4', data.term4Lock, false);
                        });
                });
        }

        function applyTermLockForNewLearner(selector, lockFlag, isCurrentTerm) {
            var $input = $(selector);

            if ($input.length === 0) {
                return;
            }

            // For new learners, never set readonly — allow entering initial values.
            // Only default empty fields to '0' when the term is locked.
            $input.prop('readonly', false);

            if (parseInt(lockFlag, 10) === 1 && !isCurrentTerm) {
                if ($input.val().length === 0) {
                    $input.val('0');
                }
            }
        }

        function learnerForm() {


            $.get(c_websiteurl + "app.php/learners/schools_json/")
                .done(function (data) {
                    var json = safeParse(data);
                    var schoolscbo = '<select name="schoolID" id="schoolID" class="form-control">';
                    schoolscbo += '<option value="0">Please select an option...</option>';
                    json.forEach(school => {
                        schoolscbo += '<option value="' + school.id + '" ' +  '>' + school.name + '</option>';
                    });
                    schoolscbo += '</select>';
                    $('#schools-container').html(schoolscbo);

                    // Onchange build school contacts cbo.
                    $('#schoolID').change(function () {
                        var selectedOption = $(this).find('option:selected').text();
                        // Update term payments info.
                        $.get(c_websiteurl + "app.php/learners/school_json/?id=" + $(this).val())
                            .done(function (data) {
                                var json = safeParse(data);
                                $('#term-payments-info').html(
                                    "The base term FEE for <span class='text-danger'>" + json.name + "</span>" +
                                    "             is <span class='text-danger'>R " + json.baseFee + "</span> per term."
                                );
                                // Update term fees.
                                // Disabled 04 Feb 2025. #200: statements to learners on waiting list
                                // $("#term1").val(json.baseFee);
                                // $("#term2").val(json.baseFee);
                                // $("#term3").val(json.baseFee);
                                // $("#term4").val(json.baseFee);
                                if ($("#term1").val().length == 0) {
                                    $("#term1").val('0');
                                }
                                if ($("#term2").val().length == 0) {
                                    $("#term2").val('0');
                                }
                                if ($("#term3").val().length == 0) {
                                    $("#term3").val('0');
                                }
                                if ($("#term4").val().length == 0) {
                                    $("#term4").val('0');
                                }
                                enforceTermLocks();
                            });
                        $.get(c_websiteurl + "app.php/learners/schoolcontacts_json/?id=" + $(this).val())
                            .done(function (data) {
                                var json = safeParse(data);
                                var cbo = '<select name="schoolContactID" class="form-control">';
                                cbo += '<option value="0">Please select an option...</option>';
                                json.forEach(contact => {
                                    cbo += '<option value="' + contact.id + '" ' +  '>' + contact.contactName + ' - ' + contact.contactLocation + '</option>';
                                });
                                cbo += '</select>';
                                $('#schoolcontacts-container').html(cbo);
                            });
                    });

                    // Auto select the first school after 1 second.
                    setTimeout(function() {
                        $("#schoolID option:eq(1)").prop('selected', true);

                        // Fire the change event for the #schoolID select element
                        $("#schoolID").change();
                    }, 1000);
                });

            var gradescbo = '<select name="grade" class="form-control">';
            gradescbo += "<option value='0' " + ("" == '0' ? 'selected' : '') +  ">Select a school grade</option>";
            gradescbo += "<option value='00' " + ("" == '00' ? 'selected' : '') + ">Grade 00</option>";
            gradescbo += "<option value='R' " + ("" == 'R' ? 'selected' : '') + ">Grade R</option>";
            gradescbo += "<option value='1' " + ("" == '1' ? 'selected' : '') + ">Grade 1</option>";
            gradescbo += "<option value='2' " + ("" == '2' ? 'selected' : '') + ">Grade 2</option>";
            gradescbo += "<option value='3' " + ("" == '3' ? 'selected' : '') + ">Grade 3</option>";
            gradescbo += "<option value='4' " + ("" == '4' ? 'selected' : '') + ">Grade 4</option>";
            gradescbo += "<option value='5' " + ("" == '5' ? 'selected' : '') + ">Grade 5</option>";
            gradescbo += "<option value='6' " + ("" == '6' ? 'selected' : '') + ">Grade 6</option>";
            gradescbo += "<option value='7' " + ("" == '7' ? 'selected' : '') + ">Grade 7</option>";
            gradescbo += '</select>';

            $("#learner-container").html(
                "" +
                "   <div id='div-duplication-message' style='margin: 0px !important; margin-top: 10px !important; '></div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">SURNAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control\" id=\"surname\" placeholder=\"Enter surname\" name=\"surname\" value=\"\">" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">NAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"name\" placeholder=\"Enter name\" name=\"name\" value=\"\">" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <label class=\"control-label col-sm-2\">GENDER:</label>" +
                "      <div class=\"col-sm-10\" style='white-space: pre !important;'>" +
                "Boy&nbsp;" +
                "<input type='radio' name='gender' value='m' " + ("" == "m" ? "checked" : "") + ">" +
                "  <span>&nbsp;Girl</span>" +
                " <input type='radio' name='gender' value='f' " + ("" == "f" ? "checked" : "") + ">" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">DATE OF BIRTH:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input style='padding-left: 10px;' type='date' id='birthDate' name='birthDate' value='" + "" + "' >" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">SCHOOL:</label>" +
                "      <div class=\"col-sm-10\" id='schools-container'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">GRADE:</label>" +
                "      <div class=\"col-sm-10\">" +
                        gradescbo + "" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">TEACHER:</label>" +
                "      <div class=\"col-sm-10\" id='schoolcontacts-container'>" +
                "      <select name=\"schoolContactID\" class=\"form-control\">" +
                "           <option value=\"0\">Please select an option...</option>" +
                "      </select>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <label class=\"control-label col-sm-2\">AFTERCARE:</label>" +
                "      <div class=\"col-sm-10\" style='white-space: pre !important;'>" +
                " Yes&nbsp;" +
                "<input  type='radio' name='aftercare' value='yes' " + ("" == "yes" ? "checked" : "") + ">" +
                "  <span>&nbsp;&nbsp;No&nbsp;</span>" +
                "<input  type='radio' name='aftercare' value='no' " + ("" == "no" ? "checked" : "") + ">" +
                "</div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <label class=\"control-label col-sm-2\">LANGUAGE:</label>" +
                "      <div class=\"col-sm-10\" style='white-space: pre !important;'>" +
                " English" +
                "  <input type='radio' name='language' value='eng' " + ("" == "eng" ? "checked" : "") + ">" +
                "  <span>&nbsp;&nbsp;Afrikaans&nbsp;</span>" +
                "<input  type='radio' name='language' value='afr' " + ("" == "afr" ? "checked" : "") + ">" +
                "  </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <label class=\"control-label col-sm-2\">PHOTOGRAPHS:</label>" +
                "      <div class=\"col-sm-10\" style='white-space: pre !important;'>" +
                " <input  type='checkbox' name='allowPhotograph' value='1' " + ("" == "1" ? "checked" : "") + ">&nbsp;&nbsp;ALLOW" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <label class=\"control-label col-sm-2\">ALLERGIES:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <textarea class='form-control' name='allergies'>" + "" + "</textarea>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">3RD PARTY NAME:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <input type=\"text\" class=\"form-control form-group-sm\" id=\"thirdPartyName\" placeholder=\"Enter the 3rd party name\" name=\"thirdPartyName\" value='" + "" + "'>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <label class=\"control-label col-sm-2\">3RD PARTY EMAIL:</label>" +
                "      <div class=\"col-sm-10\">" +
                "        <div class=\"input-group\">" +
                "          <input type=\"email\" class=\"form-control form-group-sm\" id=\"thirdPartyEmail\" placeholder=\"Enter the 3rd party email\" name=\"thirdPartyEmail\" value='" + "" + "'>" +
                "          <span class=\"input-group-addon\" style='min-width: 50px;'><img src=\"/img/tabler/mail.svg\" alt=\"\" style=\"height: 18px; width: 18px;\" /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class='card mb-3' style='border:1px solid #e6e7e9;border-radius:6px;overflow:hidden;'>" +
                "      <div class='card-header' style='background:#f4f6fa;padding:10px 16px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e6e7e9;'>" +
                "        <div style='font-size:12px;font-weight:700;letter-spacing:.05em;color:#6b7280;text-transform:uppercase;'>Term Payments</div>" +
                "        <div style='font-size:11px;color:#6b7280;' id='term-payments-info'>Select a school to see base fee</div>" +
                "      </div>" +
                "      <div class='card-body' style='padding:14px 16px;'>" +
                "        <div style='display:flex;gap:12px;flex-wrap:nowrap;'>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 1</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term1' name='term1' value=''>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 2</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term2' name='term2' value=''>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 3</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term3' name='term3' value=''>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 4</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term4' name='term4' value=''>" +
                "          </div>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\" style='padding-top: 15px; padding-left: 25px;'>" +
                "        <button disabled type=\"button\" id='btn-insert-learner' class=\"btn btn-primary btn-sm\">INSERT LEARNER</button>" +
                "<span style='white-space: pre !important;'>&nbsp;&nbsp;&nbsp;<input type=checkbox id=\"chkConfirm\"> Confirm insert action. </span>" +
                "        <div id='div-message' style='margin: 0px !important; margin-top: 10px !important; '></div>" +
                "      </div>" +
                "    </div>"
            );

            // Sleep 1/2 second and then show.
            setTimeout(function() {
                $('#learner-container').show();

                // Duplication check.
                // Once surname and name is populated then check for duplicate learners.
                // Show alert and allow override.
                $('#name').change(function () {
                    if ($('#name').val().trim() != '' && $('#name').val().trim() != '') {
                        var hr    = new XMLHttpRequest();
                        var url   = c_websiteurl + "app.php/learners/duplicationCheck/";
                        var vars  = "data=" + escape( $("#frm-main").serialize() );
                        hr.open("POST", url, true);
                        hr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        hr.onreadystatechange = function() {
                            if (hr.readyState == 4) {
                                var response = hr.responseText;
                                var json = safeParse(hr.responseText);
                                console.log(json);
                                $('#div-duplication-message').html('');
                                if (json.count > 0) {
                                    $('#div-duplication-message').html(
                                        '<div class="alert alert-warning" style="background: #e65100 !important;" role="alert">' +
                                        '<span style="white-space: pre !important; font-size: 14px;"><img src="/img/tabler/circle-x.svg" alt="" style="height: 14px; width: 14px;" />&nbsp;&nbsp;&nbsp;Duplicate learner already exists.</span>' +
                                        JSON.stringify(json.results) +
                                        '<div class="checkbox-custom">' +
                                        '   <input class="checkbox-custom" style="position:relative; top: 4px;" type="checkbox" id="chkOverrideDuplicate">' +
                                        '       <label htmlFor="customCheckbox">&nbsp;&nbsp;Allow duplicate override</label>' +
                                        '</div>' +
                                    '</div>'
                                )
                                    ;
                                    document.getElementById('btn-insert-learner').disabled = true;

                                    // When chkOverrideDuplicate is unchecked then disable btn-insert-learner.
                                    document.getElementById('chkOverrideDuplicate').addEventListener('change', function () {
                                        if ($('#chkOverrideDuplicate').is(':checked')) {
                                            // Logic already handled below this script.
                                        } else {
                                            document.getElementById('btn-insert-learner').disabled = true;
                                        }
                                    });
                                }
                            }
                        }
                        hr.send(vars);
                    }
                });
            }, 500);
        }

        $('.comments-panel').hide();
        learnerForm();
        motherForm();
        fatherForm();

        // When chkConfirm is checked then enable btn-update-learner.
        document.getElementById('chkConfirm').addEventListener('change', function () {
            if (this.checked) {
                // Make sure mother or father info filled in.
                if ($('#fatherEmail').val() != '' || $('#fatherCell').val() != '' || $('#motherEmail').val() != '' || $('#motherCell').val() != '') {
                    document.getElementById('btn-insert-learner').disabled = false;
                    // If chkOverrideDuplicate exists and is checked then enable btn-insert-learner.
                    if ($('#chkOverrideDuplicate').length > 0) {
                        if ($('#chkOverrideDuplicate').is(':checked')) {
                            document.getElementById('btn-insert-learner').disabled = false;
                        } else {
                            document.getElementById('btn-insert-learner').disabled = true;
                        }
                    }
                } else {
                    document.getElementById('btn-insert-learner').disabled = true;
                }
            } else {
                document.getElementById('btn-insert-learner').disabled = true;
            }
        });

        $('#btn-insert-learner').click(function () {
            document.getElementById('btn-insert-learner').disabled = true;

            var hr    = new XMLHttpRequest();
            var url   = c_websiteurl + "app.php/learners/store/";
            var vars  = "data=" + escape( $("#frm-main").serialize() );

            hr.open("POST", url, true);
            hr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            hr.onreadystatechange = function() {
                if (hr.readyState == 4) {
                    var response = hr.responseText;

                    if (hr.status == 200) {
                        $('#div-message').html(
                            '<div class="alert alert-warning" role="alert">' +
                            '<span style="white-space: pre !important; font-size: 14px;"><img src="/img/tabler/square-check.svg" alt="" style="height: 14px; width: 14px;" />&nbsp;&nbsp;&nbsp;Learner inserted. <a href="' + c_websiteurl + 'app.php/learners/index2/">Refresh page</a> to view learner. </span>' +
                            '</div>'
                        );
                    } else {
                        $('#div-message').html(
                            '<div class="alert alert-danger" role="alert">' +
                            '<span style="white-space: pre !important; font-size: 14px;"><img src="/img/tabler/circle-x.svg" alt="" style="height: 14px; width: 14px;" />&nbsp;&nbsp;&nbsp;Failed.</span>' +
                            hr.responseText +
                            '</div>'
                        );
                    }
                }
            }
            hr.send(vars);
        });
    }
}

window.customElements.define('new-learner-component', NewLearnerComponent);
